module.exports = __webpack_public_path__ + "img/node-dark.df3d9993.svg";